import React, { useState } from "react";
import {
  Box,
  Stack,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  crossIcon,
  crossIconDiv,
  fontSizeSchemes,
} from "../../../../assets/commonFunction";
import {
  SearchBox,
  CustomInput,
  ChatSearchButton,
  SmallIcon,
} from "../../../../common/chatComponents/ScreenSearchSection";
import searchIcon from "../../../../assets/images/chats/searchIcon.svg";
import topicIcon from "../../../../assets/images/chats/topic.svg";

const classes = {
  drawerBody: {
    minWidth: "31.25rem",
    maxWidth: "31.25rem",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    height: "100%",
  },
  header: {
    backgroundColor: "#E1E1E1",
    color: "black",
    padding: "7px 8px",
  },
  iconDiv: crossIconDiv,
  iconn: crossIcon,
  searchContainer: {
    padding: "10px 25px",
  },
  topicList: {
    flex: 1,
    overflow: "auto",
    "&::-webkit-scrollbar": {
      width: "2px",
      padding: "0px 2px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#F9F8F8",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "grey",
    },
  },
  topicItem: {
    "&:hover": {
      backgroundColor: "#F5F5F5",
    },
  },
  topicIcon: {
    width: "16px",
    height: "16px",
    marginRight: "1px",
  },
  topicText: {
    color: "#000000",
    fontSize: fontSizeSchemes.font14,
    fontWeight: "400",
  },
};

const TaskTopicList = ({
  handlecloseTopiclist,
  handleSelectGroupTopic,
  groupTopicList,
  groupSubtopicList = [],
}) => {
  const [searchQuery, setSearchQuery] = useState("");

  const getSubtopicsForTopic = (topicId) =>
    (groupSubtopicList || [])
      .filter((s) => (s.topicId || s.topic_id) === topicId)
      .sort((a, b) => a.order - b.order);
  const filteredTopicData =
    groupTopicList?.length &&
    groupTopicList?.filter((item) =>
      item?.name?.toLowerCase().includes(searchQuery.toLowerCase()),
    );

  // Get the topics to display - either filtered data or all data
  const topicsToDisplay = searchQuery
    ? filteredTopicData || []
    : groupTopicList || [];

  const handleTopicSelect = (topic) => {
    if (handleSelectGroupTopic) {
      handleSelectGroupTopic(topic, null);
    }
    handlecloseTopiclist();
  };

  const handleSubtopicSelect = (topic, subtopic) => {
    if (handleSelectGroupTopic) {
      handleSelectGroupTopic(topic, subtopic);
    }
    handlecloseTopiclist();
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  return (
    <React.Fragment>
      <Box sx={classes.drawerBody}>
        <Stack>
          {/* Header */}
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={classes.header}
          >
            <Stack direction="row" alignItems="center" spacing={2}>
              <Typography sx={classes.iconDiv}>
                <CloseIcon sx={classes.iconn} onClick={()=>handlecloseTopiclist("closeButton")} />
              </Typography>
              <Typography variant="subtitle2">Topic</Typography>
            </Stack>
          </Stack>

          {/* Search Bar */}
          <Box sx={classes.searchContainer}>
            <SearchBox>
              <CustomInput
                value={searchQuery}
                onChange={handleSearchChange}
                placeholder="Search"
              />
              <ChatSearchButton size="small" variant="contained">
                <SmallIcon src={searchIcon} />
              </ChatSearchButton>
            </SearchBox>
          </Box>

          {/* Topic List */}
          <Box sx={classes.topicList}>
            <List>
              {topicsToDisplay?.length > 0 &&
                topicsToDisplay?.map((topic, index) => {
                  const subtopics = searchQuery ? [] : getSubtopicsForTopic(topic?.id);
                  return (
                    <React.Fragment key={topic?.id || index}>
                      <ListItem disablePadding sx={classes.topicItem}>
                        <ListItemButton
                          onClick={() => handleTopicSelect(topic)}
                          sx={{ padding: "0px 25px" }}
                        >
                          <ListItemIcon sx={{ minWidth: "25px" }}>
                            <img
                              src={topicIcon}
                              alt="topic"
                              style={classes.topicIcon}
                            />
                          </ListItemIcon>
                          <ListItemText
                            primary={topic?.name || `Topic ${index + 1}`}
                            sx={{ "& .MuiListItemText-primary": classes.topicText }}
                          />
                        </ListItemButton>
                      </ListItem>
                      {subtopics.map((sub) => (
                        <ListItem key={sub.id} disablePadding sx={classes.topicItem}>
                          <ListItemButton
                            onClick={() => handleSubtopicSelect(topic, sub)}
                            sx={{ padding: "0px 25px 0px 48px" }}
                          >
                            <ListItemText
                              primary={sub.name}
                              sx={{
                                "& .MuiListItemText-primary": {
                                  ...classes.topicText,
                                  fontSize: "0.78rem",
                                  color: "#555",
                                },
                              }}
                            />
                          </ListItemButton>
                        </ListItem>
                      ))}
                    </React.Fragment>
                  );
                })}

              {/* Show message if no topics found after search */}
              {topicsToDisplay.length === 0 && searchQuery && (
                <ListItem disablePadding>
                  <ListItemText
                    primary="No topics found"
                    sx={{
                      padding: "16px 25px",
                      "& .MuiListItemText-primary": {
                        ...classes.topicText,
                        color: "#999",
                        fontStyle: "italic",
                      },
                    }}
                  />
                </ListItem>
              )}

              {/* Show default message if no topics exist */}
              {topicsToDisplay.length === 0 && !searchQuery && (
                <ListItem disablePadding>
                  <ListItemText
                    primary="No topics available"
                    sx={{
                      padding: "16px 25px",
                      "& .MuiListItemText-primary": {
                        ...classes.topicText,
                        color: "#999",
                        fontStyle: "italic",
                      },
                    }}
                  />
                </ListItem>
              )}
            </List>
          </Box>
        </Stack>
      </Box>
    </React.Fragment>
  );
};

export default TaskTopicList;
